<template>
  <div class="header-nav-wrapper" :style="'background-color:' + navColor">
    <div class="nav-container">
      <nav class="navbar navbar-default">
        <div class="navbar-header">
          <a class="navbar-brand">
            <router-link to="/">
            <img :src="logo1" alt="广州幂动科技"/>
          </router-link>
          </a>
          <a class="submenu" v-on:click.stop="toggleMenu"></a>
        </div>
        <div class="menu-bar" :style="showMenuStyle">
          <el-menu
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            text-color="#FFF"
            active-text-color="#FFFFFF"
            router>
            <el-menu-item index="/">{{ $t("route.home") }}</el-menu-item>
            <!-- <el-menu-item index="/aso">
              <a target="_blank" href="http://www.baimutech.com">{{ $t("route.aso") }}</a>
            </el-menu-item> -->
            <el-menu-item index="/yuetoutiao">
              <a target="_blank" href="http://www.ytoutiao.net/">{{ $t("route.ytoutiao") }}</a>
            </el-menu-item>
            <!-- <el-menu-item index="/taobaoke">
              <a target="_blank" href="http://www.midongtech.com/teyouhui/">{{ $t("route.tbaoke") }}</a>
            </el-menu-item> -->
            <el-menu-item index="/contactus">{{ $t("route.contactus") }}</el-menu-item>
            <!-- <el-menu-item index="/joinus">招贤纳士</el-menu-item> -->
          </el-menu>
        </div>

        <el-dropdown trigger="click" @command="handleCommand" style="line-height: 60px; width: 50px; margin: 0 20px;">
            <span class="el-dropdown-link" style="color: #BFC3CC;">
              {{ lang }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh">中文</el-dropdown-item>
            <el-dropdown-item command="ja">日本語</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button class="login-button" @click="toLogin()">登录</el-button> -->
      </nav>
    </div>
  </div>
</template>

<script>
  import { changeLang, getLang } from '@/lang/index'

  export default {
    data() {
      return {
        lang: '',
        activeIndex: '1',
        logo1: 'https://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/logo2.png',
        showMenuStyle: {},
        navColor: '#000000'
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        window.scrollTo(0, 0);
        this.toggleMenu();
      },
      toggleMenu() {
        if (this.showMenuStyle.display === undefined || this.showMenuStyle.display === 'none') {
          this.navColor = 'rgba(54, 59, 64, 1)';
          this.showMenuStyle = { display : 'block'}
        } else if (window.screen.width <= 640) {
          this.showMenuStyle = { display: 'none' }
        }
      },
      handleCommand(command) {
        this.lang = command === 'ja' ? '日本語' : '中文';
        changeLang(command);
        location.reload();
      },
      toLogin () {
        window.location = 'http://51zhuanhongbao.com/admin';
      }
    },
    created: function() {
      let lang = getLang();
      this.lang = lang === 'ja' ? '日本語' : '中文';

      let $vue = this;
      window.addEventListener('click', function() {
        if (window.screen.width <= 640 && $vue.showMenuStyle.display === 'block') {
          $vue.showMenuStyle = { display: 'none' }
        }
      });
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .header-nav-wrapper {
    width: 100%;
    position: fixed;
    z-index: 99;
    top: 0px;
    .nav-container {
      padding: 0 15px;
      margin: 0 auto;
      @media (min-width: 768px) {
        width: 750px;
      }
      @media (min-width: 992px) {
        width: 970px;
      }
      @media (min-width: 1200px) {
        width: 1170px;
      }
    }
  }
  .navbar {
    position: relative;
    min-height: 60px;
    margin-bottom: 20px;
    border: solid 1px transparent;
  }
  .navbar-default {
    color: $color-text-default-white;
    margin-bottom: 0px;
    position: relative;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .navbar-brand {
      line-height: 60px;
      display: inline-block;
      float: left;
      img {
        vertical-align: middle;
        margin-left: 10px;
      }
    }
    a.submenu {
      line-height: 60px;
      height: 30px;
      width: 40px;
      vertical-align: middle;
      display: none;
      transition: all ease 0s;
      float: right;
      background: url("/static/images/submenu.png");
      background-size: cover;
      margin-top: 15px;
      @media (max-width: 640px) {
        display: block;
      }
    }
    .menu-bar {
      padding-right: 15px;
      float: right;
      flex-grow: 1;
      @media (max-width: 640px) {
        padding: 10px 0px;
        float: none;
        max-height: 350px;
        overflow: auto;
        width: 100%;
        display: none;
      }
      .el-menu-demo {
        float: right;
      }
      a {
        text-decoration: none;
      }
      .el-menu {
        background-color: transparent;
        color: $color-text-default-white;
      }
      .el-menu--horizontal {
        border-bottom: none;
      }
      .el-menu-item {
        @media (max-width: 640px) {
          width: 100%;
          text-align: center;
          height: 40px;
          line-height: 40px;
        }
      }
      .el-menu-item:hover, .el-menu-item:focus {
        background-color: $color-header-bg;
        border-bottom: solid 2px $color-text-default-white !important;
      }
    }

    .login-button {
      width: 80px;
      height: 40px;
      background-color: rgba(0,0,0,0);
      color: #ffffff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/y-header/y-header.vue